export default "__VITE_ASSET___nRTdQsd__"